import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { Button } from '@noths/polaris-design-system-core-components';

import { NOTHSAndMoreLogo } from './NOTHSAndMoreLogo';
import * as styles from './MembershipBanner.styles';

const BACKGROUND_IMAGE_URL =
  'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt25030383015394f8/682498e93d5f42d7342496e3/membership_banner_background.jpeg';

export interface MembershipBannerProps {
  backgroundImageUrl?: string;
  buttonHref?: string;
  buttonText?: string;
  copy?: string;
  heading: string;
  onButtonClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onVisible?: () => void;
}

export const MembershipBanner = ({
  backgroundImageUrl = BACKGROUND_IMAGE_URL,
  buttonHref,
  buttonText,
  copy,
  heading,
  onButtonClick = () => {},
  onVisible = () => {},
}: MembershipBannerProps) => {
  const observedElementRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  return (
    <div css={styles.root(backgroundImageUrl)} ref={observedElementRef}>
      <div css={styles.logo}>
        <NOTHSAndMoreLogo />
      </div>
      <div css={styles.content}>
        <h3 css={styles.heading}>{heading}</h3>
        <div css={styles.body}>
          {copy && <p dangerouslySetInnerHTML={{ __html: copy }} />}
          <div css={styles.button}>
            {buttonText && buttonHref && (
              <Button href={buttonHref} inverted onClick={onButtonClick}>
                {buttonText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
